import { render, staticRenderFns } from "./CourseAreaListItem.vue?vue&type=template&id=22e6d8da&scoped=true&"
import script from "./CourseAreaListItem.vue?vue&type=script&lang=js&"
export * from "./CourseAreaListItem.vue?vue&type=script&lang=js&"
import style0 from "./CourseAreaListItem.vue?vue&type=style&index=0&id=22e6d8da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e6d8da",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex})
